<div [ngClass]="{'custom-dropdown': size === 'normal', 'small-custom-dropdown': size === 'small'}">
  <div
  [ngClass]="{'dropdown-label': size === 'normal', 'small-dropdown-label': size === 'small', disabled: disabled }"
  (click)="toggleDropdown()"  role="button"  tabindex="-1"
>
  <div class="chip-list">
    <div *ngIf="selectedItems.length === 0; else elseBlock">
      {{ placeholder }}
    </div>
    <ng-template #elseBlock>
      <div
        *ngFor="let item of selectedItems"
        [ngClass]="{'chip': size === 'normal', 'small-chip': size === 'small' }"
        (click)="clickChip($event, item)" role="button"  tabindex="-1"
      >
      <span  [ngClass]="{'highlight':item?.highlight }">{{ item?.label }}</span>
        <span
          (click)="toggleOption(item); $event.stopPropagation()" role="button"  tabindex="-1"
          class="close-btn"
        >
          &#10005;
        </span>
      </div>
    </ng-template>
  </div>
  <div class="dropdown-icon">
    <i class="fa-solid fa-caret-down"></i>
  </div>
</div>


  <div class="dropdown-menu" *ngIf="isOpen">
    <div class="filter-input" *ngIf="filter">
      <input
        type="text"
        [(ngModel)]="searchText"
        class="form-control"
        [placeholder]="'dropdown.filter.placeholder' | translate"
        (input)="filterOptions()"
      />
    </div>
    <div>
      <div class="dropdown-option" *ngIf="selectAll">
        <input
          type="checkbox"
          class="form-check-input"
          [disabled]="disabled"
          [checked]="isAllSelected()"
          (click)="toggleSelectAll($event)" role="button"  tabindex="-1"
        />
        {{ "dropdown.all" | translate }}
      </div>
      <div
        *ngFor="let option of filteredOptions"
        [ngClass]="{ selected: isSelected(option.value) }"
        class="dropdown-option"
      >
        <input
          type="checkbox"
          [disabled]="disabled"
          class="form-check-input"
          [checked]="isSelected(option.value)"
          (click)="toggleOption(option)" role="button"  tabindex="-1"
        /> 
        <span class="option-label"> {{ option.label }} </span>
      </div>
    </div>
  </div>
</div>
